module.exports = __webpack_public_path__ + "static/media/sample_02.274e6a1c.jpg";